// SPDX-License-Identifier: AGPL-3.0-or-later
/**
 * The product name, in one place. "Almanac" is a working name only, so
 * messages say {app} and the web build reads this for the page title and the
 * install manifest. Renaming the app means changing this line.
 */
export const APP_NAME = "Almanac";
//# sourceMappingURL=brand.js.map